import _omit from "lodash/omit";

const initialState = {
	activeSection: "",
	activeSectionCheckoutLoading: false,
	activeSectionErrors: {},
	activePayment: false,
	delivery: [],
	shipping: [],
	billing: [],
	notes: "",
	pickup: "",
	order: false,
	payment: [],
	deliveryErrors: {},
	shippingErrors: {},
	billingErrors: {},
	orderErrors: {},
	paymentErrors: {},
	shippingCheckInProgress: false,
	billingCheckInProgress: false,
	paymentInProcess: false,
	isStore: false
};

export default (state = initialState, action) => {
	switch (action.type) {
		// Store Flag
		case "SET_IS_STORE":
			return {
				...state,
				isStore: action.isStore
			};

		// ===================================
		//  DELIVERY
		// ===================================
		case "SET_DELIVERY":
			const store = action.store;
			const storeWithoutId = _omit(store, ["id", "title"]);

			return {
				...state,
				delivery: store,
				shipping: {
					...storeWithoutId,
					company: store.title,
					delivery_id: store.id
				}
			};

		case "SET_DELIVERY_SAVING":
			return {
				...state,
				saving: true
			};

		case "SET_DELIVERY_SAVED":
			return {
				...state,
				saving: false
			};

		// ===================================
		//  SHIPPING
		// ===================================
		case "SHIPPING_CHECK_IN_PROCESS":
			return {
				...state,
				shipping: [],
				shippingErrors: {},
				shippingCheckInProgress: true
			};
		case "SHIPPING_CHECK_ERROR":
			return {
				...state,
				shippingErrors: action.err,
				shippingCheckInProgress: false
			};
		case "SHIPPING_CHECK_SUCCESS":
			return {
				...state,
				shipping: action.payload,
				shippingCheckInProgress: false
			};

		case "SET_SAVED_SHIPPING_ADDRESS":
			return {
				...state,
				shipping: action.data
			};

		// ===================================
		//  BILLING
		// ===================================
		case "BILLING_CHECK_IN_PROCESS":
			return {
				...state,
				// billing: [],
				billingErrors: {},
				billingCheckInProgress: true
			};
		case "BILLING_CHECK_ERROR":
			return {
				...state,
				billingErrors: action.err,
				billingCheckInProgress: false
			};
		case "BILLING_CHECK_SUCCESS":
			return {
				...state,
				billing: action.payload,
				billingCheckInProgress: false
			};

		case "SET_SAVED_BILLING_ADDRESS":
			return {
				...state,
				billing: action.data
			};

		// ===================================
		//  ORDER NOTES
		// ===================================
		case "SET_ORDER_NOTES":
			return {
				...state,
				notes: action.notes
			};

		// ===================================
		//  ORDER REVIEW
		// ===================================
		case "SET_ORDER_REVIEW_COMPLETE":
			return {
				...state,
				order: true,
				activePayment: true
			};

		// ===================================
		//  PAYMENT
		// ===================================
		case "RESET_PAYMENT_ERRORS":
			return {
				...state,
				paymentErrors: {}
			};

		case "PAYMENT_IN_PROCESS":
			return {
				...state,
				paymentInProcess: true,
				paymentErrors: {}
			};

		case "PAYMENT_ERROR":
			return {
				...state,
				paymentInProcess: false,
				paymentErrors: action.err
			};

		case "PAYMENT_SUCCESS":
			return {
				...initialState
			};

		// ===================================
		//  MISC
		// ===================================
		case "CLEAR_CHECKOUT":
			return initialState;

		case "SET_ACTIVE_CHECKOUT_SECTION_LOADING":
			return {
				...state,
				activeSectionErrors: initialState.activeSectionErrors,
				activeSectionCheckoutLoading: true
			};

		case "SET_ACTIVE_CHECKOUT_SECTION_ERROR":
			return {
				...state,
				activeSectionCheckoutLoading: false,
				activeSectionErrors: action.err
			};

		case "SET_ACTIVE_CHECKOUT_SECTION_SUCCESS":
			return {
				...state,
				activeSection: action.name,
				activeSectionCheckoutLoading: false,
				activeSectionErrors: initialState.activeSectionErrors
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/checkout.js